import { useEffect, useState } from "react";
import LayoutWeb from "../LayoutWeb/layoutWeb";
import { getGroupedZones } from "../../api/zones.api";
import "./ZonesManagement.scss";
import ZonesManagementForm from "../../components/ZonesManagementForm/ZonesManagementForm";

const ZonesManagement = () => {
  const [groupedZonesData, setGroupedZonesData] = useState(null);
  const [loading, setLoading] = useState(true);

  console.log(
    "🚀 ~ file: ZonesManagement.jsx:11 ~ ZonesManagement ~ groupedZonesData:",
    groupedZonesData,
  );

  async function getGroupedZonesData() {
    setLoading(true);
    try {
      const data = await getGroupedZones();
      if (data && data.length > 0) {
        setGroupedZonesData(data);
      }
    } catch (error) {
      console.error("Error obteniendo los datos de la web:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getGroupedZonesData();
  }, []);

  return (
    <LayoutWeb subTitle="Catálogos">
      <div className="CatalogsContent pb-12">
        {/* Usamos renderizado condicional aquí */}
        {loading ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "#666" }}>
            Cargando datos de los zonas...
          </div>
        ) : groupedZonesData ? (
          <ZonesManagementForm
            webData={groupedZonesData}
            refreshData={getGroupedZonesData}
          />
        ) : (
          <div style={{ padding: "3rem", textAlign: "center", color: "red" }}>
            No se ha podido cargar la información.
          </div>
        )}
      </div>
    </LayoutWeb>
  );
};

export default ZonesManagement;
